import { Box, Button, Typography } from '@mui/material';
import { Theme, SystemStyleObject, SxProps } from '@mui/system';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { commonStyles } from '~/theme/styles/commonStyles';

interface AddRemoveBlockProps {
  add: () => void;
  remove: () => void;
  isPlusShown: boolean;
  isMinusShown: boolean;
  plusText?: string;
  minusText?: string;
  sx?: SxProps<Theme>;
  blockName?: string;
}

export const AddRemoveBlock = ({
  add,
  remove,
  isPlusShown,
  isMinusShown,
  plusText,
  minusText,
  sx,
  blockName,
}: AddRemoveBlockProps) => {
  return (
    <Box
      sx={[{ ...commonStyles.columnFlexContainer, gap: 1 }, sx] as SystemStyleObject<Theme>[]}
      data-testid={`addRemoveBlock${blockName ? `-${blockName}` : ''}`}
    >
      {isPlusShown && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            onClick={add}
            sx={commonStyles.actionButton}
            data-testid={`addBtn${blockName ? `-${blockName}` : ''}`}
          >
            <AddIcon sx={{ width: 16, height: 16 }} />
          </Button>
          <Typography variant="body1"> {plusText}</Typography>
        </Box>
      )}
      {isMinusShown && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            onClick={remove}
            sx={commonStyles.actionButton}
            data-testid={`removeBtn${blockName ? `-${blockName}` : ''}`}
          >
            <RemoveIcon sx={{ width: 16, height: 16 }} />
          </Button>
          <Typography variant="body1"> {minusText}</Typography>
        </Box>
      )}
    </Box>
  );
};
